import React, { useEffect, useState } from "react";
import axios from "axios";

const ProfileSetting = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        // LocalStorage se vendorId get karo
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) {
          console.error("vendorId not found in localStorage");
          setLoading(false);
          return;
        }

        // API call
        const res = await axios.get(`https://localhost:44370/api/Profile/${vendorId}`);
        const data = res.data;

        // Map relevant fields
        const relevantProfile = {
          VendorID: data.userId,
          FullName: data.fullName,
          Email: data.email,
          Phone: data.phone,
          StoreName: data.businessName,
          BusinessType: data.businessType,
          Website: data.website,
          Status: data.status,
          CreatedAt: data.createdAt,
        };

        setProfile(relevantProfile);
      } catch (err) {
        console.error("Error fetching profile:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading) return <div className="p-6 text-gray-500">Loading profile...</div>;
  if (!profile) return <div className="p-6 text-red-500">Profile not found!</div>;

  return (
    <div className="bg-white rounded-xl shadow-md p-6 animate-fadeIn max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Vendor Profile</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {Object.entries(profile).map(([key, value]) => (
          <div key={key} className="flex flex-col">
            <span className="text-sm text-gray-500">{key}</span>
            <span className="text-gray-800 font-medium">
              {value === null || value === undefined
                ? "N/A"
                : typeof value === "object"
                ? JSON.stringify(value)
                : value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileSetting;
